import React, { ReactNode } from "react";
import Button from "./Buttons";

interface BreadCrumbProps {
  title: string;
  children?: ReactNode;
  showSearch?: boolean;
  searchPlaceholder?: string;
  onSearch?: (e: React.FormEvent<HTMLFormElement>, searchText: string) => void;
  onSearchClear?: () => void;
  onSearchFocus?: () => void;
  rightContent?: ReactNode;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({
  title,
  children,
  showSearch = false,
  searchPlaceholder = "Search",
  onSearch,
  onSearchClear,
  onSearchFocus,
  rightContent,
}) => {
  const [searchText, setSearchText] = React.useState<string>("");
  const [prevSearchText, setPrevSearchText] = React.useState<string>("");

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(e, searchText);
    }
  };

  // Handle input change and detect clear button usage
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    // If previous value had content and new value is empty, clear was clicked
    if (prevSearchText.length > 0 && newValue === "") {
      if (onSearchClear) {
        onSearchClear();
      }
      if (onSearch) onSearch(e as any, "");
    }

    setPrevSearchText(searchText);
    setSearchText(newValue);
  };

  return (
    <div className="flex flex-col md:flex-row justify-between mb-3 gap-2">
      <div>
        <h1 className="text-xl md:text-2xl font-semibold">{title}</h1>
        {children && (
          <nav aria-label="breadcrumb">
            <ol className="flex flex-wrap items-center gap-2 text-sm text-gray-600">
              {children}
            </ol>
          </nav>
        )}
      </div>

      <div className="flex flex-col sm:flex-row mt-2 md:mt-0 gap-2">
        {showSearch && (
          <form className="flex" role="search" onSubmit={handleSearch}>
            <input
              className="form-control me-2 px-4 border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-500 w-full sm:w-64 md:w-80 min-w-0"
              type="search"
              placeholder={searchPlaceholder}
              aria-label="Search"
              value={searchText}
              onChange={handleInputChange}
              onFocus={onSearchFocus}
            />
            <Button variant="dark" type="submit">
              Search
            </Button>
          </form>
        )}
        {rightContent}
      </div>
    </div>
  );
};

export default BreadCrumb;
